import { createContext, ReactNode, useCallback, useContext, useState } from 'react'

interface ViewAsContext {
  viewAsWalletAddress: string
  onViewAsWalletAddressChange: (address: string) => void
  onCancelViewAsWallet: () => void
}

export const ViewAsWalletProvider = ({ children }: { children: ReactNode }) => {
  const [viewAsWalletAddress, setViewAsWalletAddress] = useState('')

  const onViewAsWalletAddressChange = useCallback((address: string) => setViewAsWalletAddress(address), [])

  const onCancelViewAsWallet = useCallback(() => setViewAsWalletAddress(''), [])

  return (
    <ViewAsWalletContext.Provider value={{ viewAsWalletAddress, onViewAsWalletAddressChange, onCancelViewAsWallet }}>
      {children}
    </ViewAsWalletContext.Provider>
  )
}
const ViewAsWalletContext = createContext<ViewAsContext | null>(null)

export const useViewAsWallet = (): ViewAsContext => {
  const viewAs = useContext(ViewAsWalletContext)
  if (!viewAs) {
    throw new Error('useViewAsWallet must be used within a ViewAsWalletProvider')
  }
  return viewAs
}
